import React, { useEffect, useState, useCallback } from 'react';

import { Grid } from '@material-ui/core';
import { toast } from 'react-toastify';

import estatus from '../../constantes/estatus';
import Default from '../../contenedores/Default';

import Select from '../../componentes/Select';
import TextField from '../../componentes/TextField';
import axios from '../../configuraciones/axios';

import endpoints, { SUCURSALES, EMPRESAS, TERMINALES } from '../../configuraciones/endpoints';
import { ipv4, LETTERSSPECIALCHARACTER, ONLY_NUMBERS } from '../../utilidades/regex';
import { findPropertysEmpty, requiredFIle } from '../../utilidades/functions';

import styles from './styles';
import { ELEMENTO_NO_ENCONTRADO, FORMULARIO_INVALIDO } from '../../configuraciones/mensajes';

const Terminal = ({ history, match }) => {
  const classes = styles();

  const [isSubmit, setIsSubmit] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [terminal, setTerminal] = useState({
    Nombre: '',
    Ip: '',
    Puerto: 4370,
    Checadas: 0,
    BorrarChecadas: '',
    Habilitado: '',
    Sucursal: '',
    Empresa: '',
  });
  const [empresa, setEmpresa] = useState([]);
  const [allSucursales, setAllSucursales] = useState([]);
  const [sucursal, setSucursal] = useState([]);
  const { params: { _id } } = match;

  const regresar = useCallback(() => {
    const { location: { state: { pagina } } } = history;
    history.push({
      pathname: '/catalogos/terminales',
      search: pagina && pagina > 1 ? `?pagina=${pagina}` : '',
    });
  }, [history]);

  const guardar = useCallback(async () => {
    setIsSubmit(true);

    const {
      errors, regex, totalErrors, totalRegex
    } = findPropertysEmpty(document.getElementById('frmTerminal'), true);

    const ipIsValid = ipv4.test(terminal.Ip);

    if (!ipIsValid) {
      if (totalErrors === 0 && totalRegex === 0 && !ipIsValid) {
        toast.error(FORMULARIO_INVALIDO);
      } 
      errors.Ip = true;
    }

    setFormErrors({ ...errors, ...regex });
    if (totalErrors > 0 || totalRegex > 0 || !ipIsValid)
      return;

    const metodo = _id ? 'put' : 'post';
 
    await axios[metodo](endpoints.base.url(TERMINALES), terminal)
    regresar();

  }, [_id, terminal, regresar]);

  const consultarDatosIniciales = useCallback(async () => {
    const promesas = [
      axios.get(endpoints.base.url(EMPRESAS, '/obtener-Activos')),
      axios.get(endpoints.base.url(SUCURSALES, '/obtener-Activos')),
    ];
    const [empresas,sucursales] = await Promise.all(promesas);

    setEmpresa(empresas.empresa.map(({ Nombre, id }) => ({ label: Nombre, EmpresaID: id })));
    setAllSucursales(sucursales.sucursal.map(({ Nombre, id, Empresa }) => ({ label: Nombre, SucursalID: id, EmpresaID: Empresa })));


    if (_id) {
      const terminalesResponse = await axios.get(endpoints.base.url(TERMINALES, _id))
      if (!terminalesResponse) {
        toast.warning(ELEMENTO_NO_ENCONTRADO);
        regresar();
        return;
      }
      const terminal = {
        ...terminalesResponse,
        Sucursal: terminalesResponse.Sucursal.id,
        Empresa: terminalesResponse.Sucursal.Empresa.id,
      }

      setSucursal(
        sucursales.sucursal
          .filter(s => s.Empresa === terminal.Empresa)
          .map(({ Nombre, id }) => ({ label: Nombre, SucursalID: id }))
      );
     
      setTerminal(terminal);
    }
  }, [_id, regresar])

  const handleEmpresaChange = useCallback((e) => {
    const { value } = e.target;
    setTerminal((prevState) => ({
      ...prevState,
      Empresa: value,
      Sucursal: '',
    }));

    setSucursal(
      allSucursales
        .filter(s => s.EmpresaID === value)
        .map(({ label, SucursalID }) => ({ label, SucursalID }))
    );
  }, [allSucursales]);

  

  useEffect(() => {
    consultarDatosIniciales();
  }, [_id, consultarDatosIniciales]);



  return <Default
    titulo={Boolean(_id) ? 'Editar terminal' : 'Nueva terminal'}
    placeHolder={''}
    mostrarCabeceroFormulario={false}
    guardar={guardar}
    cancelar={regresar}>

    <Grid container spacing={6} id="frmTerminal"  >
      <Grid item lg={12} md={12} sm={12} xs={12}>
        <Grid container className={classes.principales} spacing={4}>
          <Grid item xs={4}>
            <TextField
              label="Nombre de terminal"
              onChange={setTerminal}
              name="Nombre"
              value={terminal.Nombre}
              isHandleChange
              inputProps={{ regex: LETTERSSPECIALCHARACTER, maxLength: 50, regexonchange: 'true' }}
              error={formErrors.Nombre}
              helperText={requiredFIle(isSubmit, formErrors, 'Nombre')}
              required
            />
          </Grid>
          <Grid item xs={4}>
            <Select
              label="Empresa"
              required
              options={empresa}
              onChange={handleEmpresaChange}
              name="Empresa"
              value={terminal?.Empresa || ''}
              valueProp={'EmpresaID'}
              error={formErrors.Empresa}
              placeHolder={'Seleccione'}
              helperText={requiredFIle(isSubmit, formErrors, 'Empresa')}
              isHandleChange={false}
            />
          </Grid>
           <Grid item xs={4}>
            <Select
              label="Sucursal"
              required
              options={sucursal}
              onChange={setTerminal}
              name="Sucursal"
              value={terminal.Sucursal || ''}
              valueProp={'SucursalID'}
              error={formErrors.Sucursal}
              placeHolder={'Seleccione'}
              helperText={requiredFIle(isSubmit, formErrors, 'Sucursal')}
              isHandleChange
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              label="Dirección IP"
              onChange={setTerminal}
              name="Ip"
              value={terminal.Ip}
              isHandleChange
              inputProps={{ maxLength: 15 }}
              error={formErrors.Ip}
              helperText={requiredFIle(isSubmit, formErrors, 'Ip')}
              required
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              label="Puerto"
              onChange={setTerminal}
              name="Puerto"
              value={terminal.Puerto.toString()}
              isHandleChange
              inputProps={{ regex: ONLY_NUMBERS, maxLength: 5, regexonchange: 'true' }}
              error={formErrors.Puerto}
              helperText={requiredFIle(isSubmit, formErrors, 'Puerto')}
              required
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              label="No. Checadas"
              onChange={setTerminal}
              name="Checadas"
              value={terminal.Checadas.toString()}
              isHandleChange
              inputProps={{ regex: ONLY_NUMBERS, maxLength: 20, regexonchange: 'true' }}
              error={formErrors.Checadas}
              helperText={requiredFIle(isSubmit, formErrors, 'Checadas')}
              required
            />
          </Grid>
          <Grid item xs={4}>
            <Select
              label="Borrar checadas"
              options={estatus}
              onChange={setTerminal}
              name="BorrarChecadas"
              value={terminal.BorrarChecadas}
              error={formErrors.BorrarChecadas}
              helperText={requiredFIle(isSubmit, formErrors, 'BorrarChecadas')}
              placeHolder={'Seleccione'}
              isHandleChange
              required
            />
          </Grid>
          <Grid item xs={4}>
            <Select
              label="Estatus"
              options={estatus}
              onChange={setTerminal}
              name="Habilitado"
              value={terminal.Habilitado}
              error={formErrors.Habilitado}
              helperText={requiredFIle(isSubmit, formErrors, 'Habilitado')}
              placeHolder={'Seleccione'}
              isHandleChange
              required
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  </Default>;
};

export default React.memo(Terminal);
